<!-- 数字输入框 -->
<template>
  <div class="flex items-center justify-end">
    <img
      :src="subImg"
      class="w-20px h-20px"
      @click="sub"
    >
    <input
      v-bind="getBindValue"
      @input="handleInput"
      @blur="handleBlur"
      ref="customNumberInputRef"
      class="w-100px h-24px rounded-4px flex items-center mx-10px"
      style="border: 1px solid #ccc;"
    >
    <img
      :src="addImg"
      class="w-20px h-20px"
      @click="add"
    >
  </div>
</template>

<script lang="ts" setup>
import { computed, useAttrs, ref, watch, nextTick } from 'vue'
import { customNumberInputProps } from './props'
import addImg from '@/assets/images/add.png'
import subImg from '@/assets/images/sub.png'

/* data 数据 */
const customNumberInputRef = ref()
const props = defineProps(customNumberInputProps)
const attrs = useAttrs()
const emits = defineEmits(['update:modelValue', 'add', 'sub'])
const alignObj = {
  left: 'text-left',
  right: 'text-right',
  center: 'text-center',
}

const innerValue = ref(String(props.modelValue || ''))

// 监听外部传值
watch(() => props.modelValue, (nv) => {
  if (String(nv) !== innerValue.value) {
    innerValue.value = String(nv)
  }
})

const getBindValue = computed(() => {
  const binds: any = {
    class: alignObj[props.textAlign] || '',
    value: innerValue.value,
    type: 'number',
    ...attrs
  }
  // 删除动态绑定的 oninput 避免与 @input 冲突
  delete binds.oninput
  delete binds.onInput
  return binds
})

const handleInput = e => {
  let rawValue = e.detail.value || ''
  let value = rawValue.replace(/[^0-9]/gi, '')
  
  // 只有在明确传了 maxlength 时才去做字符串截断，不传则不管
  if (props.maxLength !== 999) {
    value = value.slice(0, props.maxLength)
  }
  
  // 对输入值做 max 范围限制
  let num = parseInt(value)
  if (!isNaN(num)) {
    if (num > props.max) {
      num = props.max
      value = `${num}`
    }
  }
  
  // 判断输入是否被强制修改（截断了或超限了）
  if (rawValue !== value) {
    // 【核心修复】：Taro Vue3 典型的不同步 Bug
    // 如果直接把 innerValue 赋值为 value，而此时 value 恰好等于之前的合法值，
    // Vue 的 Diff 检查会认为数据没变，不仅不会派发更新给小程序，还会导致原生输入框保留着超限的文字。
    // 所以先让 VDOM 等于错误值，再在 nextTick 中拨乱反正，强行触发原生 input 层面的回传
    innerValue.value = rawValue
    nextTick(() => {
      innerValue.value = value
      if (value !== String(props.modelValue)) {
        emits('update:modelValue', value)
      }
    })
  } else {
    // 正常输入，没触发任何界限
    innerValue.value = value
    if (value !== String(props.modelValue)) {
      emits('update:modelValue', value)
    }
  }
  
  return value
}

// 失去焦点时如果为空需要还原为最小值
const handleBlur = (e) => {
  if (e.detail.value === '') {
    const minVal = props.min || 1
    emits('update:modelValue', `${minVal}`)
  }
}
const add = () => {
  if (props.modelValue) {
    const v = parseInt(props.modelValue) + 1
    if (v > props.max) {
      return // 已达到最大值，不再递增
    }
    emits('add', `${v}`)
    emits('update:modelValue', `${v}`)
  } else {
    // 一开始就点击加号的时候，默认给它赋值 min
    const v = props.min || 1
    emits('update:modelValue', `${v}`)
  }
}
const sub = () => {
  if (props.modelValue) {
    const v = parseInt(props.modelValue) - 1
    if (v < props.min) {
      return // 已达到最小值，不再递减
    }
    if (props.gZero && v <= 0) {
      return
    }
    emits('sub', `${v}`)
    emits('update:modelValue', `${v}`)
  }
}
</script>